import { useState } from 'react';
import classNames from 'classnames';
import close from '../../assets/images/close.png';
import styles from './EditGoalModal.module.css';
import { updateFundraiserApi } from "../../api/fundraisers";
import Button from '../Button.jsx';
import FormMoneyInput from "../form/FormMoneyInput";
import FormButton from "../form/FormButton";
import FormError from "../form/FormError";

const EditGoalModal = (props) => {
    const [formData, setFormData] = useState({
        goalAmount: props.fundraiser.goal_amount
    });
    const initialErrorObject = {
        goalAmount: false
    };
    const [errorObject, setErrorObject] = useState(initialErrorObject);
    const inputsMessagesErrorObject = {
        goalAmount: 'Required',
    };
    const [editGoalInProgress, setEditGoalInProgress] = useState(false);

    const checkForEmptyInputs = () => {
        setErrorObject(initialErrorObject);
        const newErrorObject = structuredClone(initialErrorObject);
        let foundError = false;
        for(const key of Object.keys(formData)){
            if(!formData[key]){
                newErrorObject[key] = inputsMessagesErrorObject[key];
                foundError = true;
            }
        }
        setErrorObject(newErrorObject);
        return foundError;
    };

    const submit = async(event) => {
        event.preventDefault();
        setErrorObject(initialErrorObject);
        setEditGoalInProgress(true);
        if(checkForEmptyInputs()){
            setEditGoalInProgress(false);
            return;
        }
        const editGoalResponse = await updateFundraiserApi(props.fundraiser.id, 'goal_amount', formData.goalAmount);
        let body;
        try{
            body = await editGoalResponse.json();
        }
        catch(e){}
        if(editGoalResponse && editGoalResponse.ok){
            props.updateFundraiserGoal(body.data.change_history_id, formData.goalAmount);
            props.close();
        }
        else{
            const error = body?.error ? body.error : 'Update fundraiser goal failed';
            setErrorObject((prevState) => ({...prevState, apiError: error}));
        }
        setEditGoalInProgress(false);
    };

    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <div className={styles.header}>
                    Edit goal
                </div>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <form className={styles.form} onSubmit={submit}>
                    <FormMoneyInput className={styles.input} label="Goal" placeholder="$0" value={formData.goalAmount}
                                    update={(event) => setFormData({...formData, goalAmount: event.target.value})} error={errorObject.goalAmount} required/>
                    {
                        errorObject.apiError && (
                            <FormError error={errorObject.apiError}/>
                        )
                    }
                    <div className={classNames(styles.buttons, {[styles.buttonsApiError]: errorObject.apiError})}>
                        <Button className={styles.button} text="Cancel" onClick={props.close}/>
                        <FormButton className={styles.button} style={{marginLeft: 'auto'}} text="Update" disabled={editGoalInProgress}/>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default EditGoalModal;